module.exports = __webpack_public_path__ + "img/icon_4_13.1e503adc.png";